import AuthMixin from '@/components/mixins/auth-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'signInSuccessful',
  inject: [
    '$currentUser',
    '$utils',
    '$api',
    '$apiError'
  ],
  mixins: [AuthMixin],
  computed: {
    showDefaultDescription () {
      let res = false

      if ((!this.$currentUser.hasGroupEnterprise() && !this.$utils.isPageForEnterprise()) || (this.$currentUser.hasGroupEnterprise() && !this.$utils.isPageForEnterprise())) {
        res = true
      }

      if (this.$currentUser.hasGroupEnterprise()) {
        res = false
      }

      return res
    },
    showEnterpriseDescription () {
      let res = false

      if ((this.$currentUser.hasGroupEnterprise() && this.$utils.isPageForEnterprise()) || (!this.$currentUser.hasGroupEnterprise() && this.$utils.isPageForEnterprise())) {
        res = true
      }

      if (this.$currentUser.hasGroupEnterprise()) {
        res = true
      }

      return res
    }
  },
  data () {
    return {
      showPlayerSetupDesc: false,
      showStorageSize: false,
      timer: null,
      timerStop: false,
      loadDescEl: false,
      productName: CONFIG.PRODUCT_NAME,
      players: {
        requestStatus: null,
        responseData: {}
      },
      storageSize: {
        requestStatus: null,
        responseData: {},
        percentage: 0
      }
    }
  },
  methods: {
    getPlayers () {
      const apiRequest = () => {
        this.$utils.mainLoader(false)
        this.error = ''
        this.players = { requestStatus: 'requesting', responseData: {}, percentage: 0 }

        this.$api.get(`${CONFIG.API_BASE_URL}/player`)
          .then(response => {
            this.$utils.mainLoader(false)
            this.players = { requestStatus: 'done', responseData: response.data.players }

            if (this.players.responseData.length === 0) {
              this.showPlayerSetupDesc = true
            }

            this.handleRedirectToPage()
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }

      if (this.$currentUser.hasGroupEnterprise()) {
        this.timer = setTimeout(() => {
          if (!this.timerStop) { this.$router.push('/menu', () => {}) }
        }, 5000)
      } else {
        apiRequest()
      }
    },
    handleStorageSizeVisibility () {
      this.showStorageSize = true

      if (this.showStorageSize) {
        this.getStorageSize()
      }
    },
    getStorageSize () {
      const getStorageSizeRequest = () => {
        this.storageSize = { requestStatus: 'requesting', responseData: {}, percentage: 0 }

        this.$api.get(`${CONFIG.API_BASE_URL}/group/storage`)
          .then(response => {
            let calPercentage = 100 * response.data.used / response.data.quota

            if (calPercentage > 100) calPercentage = 100

            this.storageSize = {
              requestStatus: 'done',
              responseData: response.data,
              percentage: calPercentage
            }

            if (calPercentage <= 75) {
              this.handleRedirectToPage()
            }
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { getStorageSizeRequest() } })
          })
      }

      getStorageSizeRequest()
    },
    handleRedirectToPage () {
      const isGetPlayersRequestDone = this.players.requestStatus === 'done'
      const isGetStorageSizeRequestDone = this.storageSize.requestStatus === 'done'

      if ((isGetPlayersRequestDone && (this.showStorageSize && isGetStorageSizeRequestDone)) || (isGetPlayersRequestDone && (!this.showStorageSize))) {
        // Redirect to menu page after 5 seconds if there are players
        if (this.players.responseData.length) {
          this.timer = setTimeout(() => {
            if (!this.timerStop) {
              this.$router.push('/menu', () => {})
            }
          }, 5000)
        }
      }

      // Redirect to menu page for enterprise user with player
      if (this.showEnterpriseDescription && !this.showPlayerSetupDesc) {
        this.timer = setTimeout(() => {
          if (!this.timerStop) {
            this.$router.push('/menu', () => {})
          }
        }, 5000)
      }
    }
  },
  beforeUnmount () {
    this.timerStop = true
    this.timer = clearTimeout(this.timer)
  },
  mounted () {
    if (this.$utils.isPageForLicenses()) {
      if (this.$currentUser.hasGroupDistributor()) {
        this.$router.push('/distributor', () => {})
      } else {
        this.$router.push('/activation', () => {})
      }
    } else {
      this.isAuthenticated({
        callback: () => {
          $('.show-animate-clouds').removeClass('ready')
          useMixpanel().track('Sign in ok')
          this.handleStorageSizeVisibility()
          this.getPlayers()
        }
      })
    }
  }
}
